<template>
    <div class="importLog">
        <!-- 导入日志 -->
        <div class="importLog">
            <!-- 面包屑导航 -->
            <div class="page-top">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">生产管理</el-breadcrumb-item>
                <el-breadcrumb-item>
                  <span @click="goBack" class="cursor-pointer">报工</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item>导入日志</el-breadcrumb-item>
            </el-breadcrumb>
            </div>
            <div class="white-background">
                <el-form :model="form" label-width="108px" size="small" style="display:flex">
                    <el-form-item label="导入时间">
                        <el-date-picker
                            v-model="form.importTime"
                            type="datetime"
                            placeholder="选择日期时间"
                            value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
                    </el-form-item>
                    <el-tooltip class="item" effect="dark" content="只保留30天的导入记录" placement="top">
                        <i class="el-icon-warning-outline"></i>
                    </el-tooltip>
                </el-form>
                <el-table
                    :data="tableData"
                    style="width: 100%">
                    <el-table-column
                        prop="time"
                        label="导入时间">
                    </el-table-column>
                    <el-table-column
                        prop="user"
                        label="导入用户">
                    </el-table-column>
                    <el-table-column
                        prop="result"
                        label="导入结果">
                    </el-table-column>
                    <el-table-column
                        prop="details"
                        label="导入详情">
                    </el-table-column>
                    <el-table-column
                        label="操作">
                        <template slot-scope="scope">
                            <el-button size="small">查看</el-button>
                            <el-button type="text" size="small">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {},
            tableData: []
        }
    },
    methods: {
        search() {

        },
        goBack(){
          this.$emit("goBack");
        }
    }
}
</script>


<style scoped>
.search {
    display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/workReport/ImportLog.vue